import styled from 'styled-components';
import { Item, ItemExternalLink, MenuTitleSmall } from '../../shared-menus';

export const UseCasesBlock = () => {
  return (
    <Root>
      <MenuTitleSmall>Use cases</MenuTitleSmall>
      <Item>
        <ItemExternalLink href="https://www.uprightproject.com/products/investors/" target="_blank">
          Asset managers
        </ItemExternalLink>
      </Item>
      <Item>
        <ItemExternalLink href="https://www.uprightproject.com/products/asset-owners/" target="_blank">
          Asset owners
        </ItemExternalLink>
      </Item>
      <Item>
        <ItemExternalLink href="https://www.uprightproject.com/products/private-equity/" target="_blank">
          Private markets
        </ItemExternalLink>
      </Item>
      <Item>
        <ItemExternalLink href="https://www.uprightproject.com/products/companies/" target="_blank">
          Companies
        </ItemExternalLink>
      </Item>
    </Root>
  );
};

const Root = styled.div``;
